import React from "react";
import "./tooltip.scss";

const Tooltip = ({ children, content }) => {
  return (
    <div className="tooltip_container">
      <div className="tooltip_trigger_container">{children}</div>
      <dialog role="tooltip">{content}</dialog>
    </div>
  );
};

export default Tooltip;
